import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, breakpoints }: Theme) => ({
  sslInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    [breakpoints.down(485)]: {
      alignItems: 'center',
    },
  },
  warranty: {
    maxWidth: 1200,
    padding: '32px 0',
  },
  warrantyInfo: {
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: 1.43,
    color: custom.grey[3],
    marginBottom: 20,
  },
  image: {
    height: 28,
    width: 55,
    marginRight: 20,
  },
  center: {
    [breakpoints.up(560)]: {
      textAlign: 'center',
    },
  },
}));
